import { SearchIcon } from "@heroicons/react/solid"
import { HttpError, useOne } from "@refinedev/core"
import Button from "components/button"
import Input from "components/input"
import Select from "components/select"
import { IOrgIdsItem } from "interfaces"
import { useState } from "react"
import { STATUS_OPTIONS } from "utills/constants"

export const Filter = ({ currentFilterValues, setFilters}: {currentFilterValues: any, setFilters: any}) => {
  
  const { data, isLoading } = useOne<IOrgIdsItem[], HttpError>({
    resource: "organization/ids",
    id: "",
    meta: {
      resource: "data"
    }
  });

  const organizationIds = (data?.data ?? []).map((org: IOrgIdsItem) => (
    { value: org.id, label: org.name_en }
  ));


  const _handleSubmitFilter = () => {
    setFilters([
      {field: "q", operator: "contains", value: keyword},
      {field: "is_active", operator: "eq", value: isActive},
      {field: "organization_id", operator: "eq", value: selectedOrganization},
      {field: "page", operator: "eq", value: 1}
    ])
  }

  const [keyword, setKeyword] = useState(currentFilterValues.q);
  const [selectedOrganization, setSelectedOrganization] = useState(currentFilterValues.organization_id);
  const [isActive, setIsActive] = useState<string>(currentFilterValues.is_active);

  return (
    <div className="w-full flex flex-col gap-y-4 md:flex-row md:items-end md:gap-x-3">
      <div className="flex-1">
        <label htmlFor="role" className="block text-sm font-medium leading-6">
          Search
        </label>
        <div className="mt-2">
          <Input 
            className="px-2 py-2"
            label='Search by Role name'
            id='role'
            type="text"
            placeholder="Search by Role name"
            value={keyword}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setKeyword(e.target.value)}
            onKeyDown={(e: React.KeyboardEvent) => {
              if (e.key === 'Enter') {
                _handleSubmitFilter();
              }
            }}
          />
        </div>
      </div>
      <div className="flex-1">
        <label htmlFor="org_name" className="block text-sm font-medium leading-6">
          Org name
        </label>
        <div className="mt-2">
          <Select 
            options={organizationIds}
            isClearable={true}
            isLoading={isLoading}
            id="status"
            placeholder="Select Organization"
            className="py-0.5"
            value={organizationIds.find((selected: {label: string; value: string}) => selected.value === selectedOrganization)}
            onChange={(selected: {label: string; value: string}) => setSelectedOrganization(selected?.value)}
          />
        </div>
      </div>
      <div className="flex-1">
        <label htmlFor="status" className="block text-sm font-medium leading-6">
          Status
        </label>
        <div className="mt-2">
          <Select 
            options={STATUS_OPTIONS} 
            isClearable={true}
            id="status"
            placeholder="Select Status"
            className="py-0.5"
            value={STATUS_OPTIONS.find((selected) => selected.value === isActive)}
            onChange={(selected: {label: string; value: "true" | "false"}) => setIsActive(selected?.value)}
          />
        </div>
      </div>
      <div className="shrink-0">
        <label htmlFor="status" className="block text-sm font-medium leading-6">
          <span className="sr-only">Search</span>
        </label>
        <div className="mt-2 w-full">
          <Button className="w-full px-4 py-2 border-y-[1px] border-solid border-brand-500 rounded-md" onClick={_handleSubmitFilter}>
            <SearchIcon className="w-3 h-4 text-white mr-2" /> Search
          </Button>
        </div>
      </div>
    </div>
  )
}